<div class="w-screen min-h-screen flex flex-col">

    <div class="flex-0">
        <gwc-frontend-header></gwc-frontend-header>
    </div>

    <div class="w-full flex-grow px-4 flex justify-center relative">
        <div class="w-full desktop:w-desktop">
            <router-outlet></router-outlet>
        </div>
    </div>

    <div class="flex-0">
        <gwc-frontend-footer></gwc-frontend-footer>
    </div>

</div>
